module.exports = __webpack_public_path__ + "img/icon_search_pink.b9daf877.png";